module.exports = __webpack_public_path__ + "static/media/bar-code-small.563f6f52.svg";